module.exports = __webpack_public_path__ + "static/media/be-BY.05ea4582.md";